export default function FormProgress({ step, total }) {
  return (
    <div className="w-full h-1.5 bg-graylight rounded-full overflow-hidden" data-testid="form-progress-bar">
      <div
        className="h-full bg-orange transition-all duration-500"
        style={{ width: `${Math.min(100, (step / total) * 100)}%` }}
      />
    </div>
  );
}
